export default "__VITE_ASSET__J$9KBSJv__"